"use strict";

var _moduleLocalization = require("@eig-builder/module-localization");

_moduleLocalization.Localizations.append({
  modules: {
    navigation: {
      siteselector: {
        group: {
          domains: 'Domains'
        },
        groupitem: {
          lastEdited: 'Last edited: ',
          unpublished: 'Unpublished',
          published: 'Published',
          unassigned: 'Unassigned'
        }
      }
    }
  }
});